export const filters = {
  STATUS: 'Status',
};

export const statusList = [
  { id: 1, name: 'Active' },
  { id: 2, name: 'Inactive' },
  { id: -1, name: 'All' },
];

export const maxDisplayColumn = 9;
